/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2645
 */

"use strict"

export { a }
import /* 0 */"react"
import * as /* [auto-meaningful-name] */React from "react"
import /* [auto-meaningful-name] */React1 from /* 0 */"react"
var o = React1.createContext(null)
function a() {
  return React1.useContext(o)
}
export default a
